module.exports = __webpack_public_path__ + "img/de.ce9b78fb.svg";